module.exports = __webpack_public_path__ + "static/media/experience_active.4113ae19.svg";